import { IEnvironment } from './environment-interface';

export const environment: IEnvironment = {
  production: false,
  apiBasePaths: {
    general: 'https://api.pu.seven-group.com',
    data: 'https://data.pu.seven-group.com',
    sales: 'https://sales.pu.seven-group.com',
    stats: 'https://stat.pu.seven-group.com',
  },
};
